export default "__VITE_ASSET__BJKJfR6o__"